import { BaseDto } from "../common/base.dto";

export class AppointmentReasonDto extends BaseDto {
  en: string
  kh: string
  type: string
  enabled: boolean
  sortOrder: number
}

export class FindAppointmentReason {
  type: string
}